import { createRichTextComponent } from '../../components/richText/utils';

/**
 * Renders rich text field with Heading 2 styles.
 */
const Heading2 = createRichTextComponent('heading2');

export default Heading2;
